import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import { apiRequest } from "../../services/api";
import { encryptData } from "../Common/encryptionUtils";
import "./VerifyEmail.css";
import { faL } from "@fortawesome/free-solid-svg-icons";
import CryptoJS from "crypto-js";
const secretKey = "BusinessTimeWebKiosk";

const VerifyUserPasscode = ({
  open,
  handlePopUpClose,
  navigate,
  userData, // Default to an empty object
  setLoading,
}) => {
  console.log("userData--->", userData);
  const [phone, setPhone] = useState("");
  const [countryPhoneCode, setCountryPhoneCode] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [confirmationResult, setConfirmationResult] = useState(null);
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);

  const handleClose = () => {
    setPhone(""); // Clear phone number input
    setOtp(""); // Clear OTP input
    setMessage(""); // Clear error/success messages
    setErrorMessage("");
    setOtpSent(false); // Reset OTP sent state
    handlePopUpClose();
  };

  const [selectedPremise, setSelectedPremise] = useState(
    JSON.parse(localStorage.getItem("selectedTopBarPremises"))
  );

  const [premiseData, setPremiseData] = useState(null);

  const fetchPremiseDetails = async (premiseData) => {
    const authToken = localStorage.getItem("authToken");
    const headers = {
      Authorization: `Bearer ${authToken}`,
    };
    const response = await apiRequest(
      `web_api/admin/getPremiseDetailsById?premise_id=${premiseData?.premise_id}`,
      "GET",
      null,
      headers
    );
    if (response?.data?.status_code == 200) {
      setPremiseData(response.data?.data);
    } else {
      setPremiseData(null);
    }
  };

  useEffect(() => {
    fetchPremiseDetails(selectedPremise);
  }, []);

  const verifyOtp = async (e) => {
    if (!otp || otp.length !== 4 || !/^\d{4}$/.test(otp)) {
      setErrorMessage("Enter a valid 4-digit Passcode.");
      return;
    }
    setIsVerifyingOtp(true);
    const payload = {
      user_id: encryptData(userData?.user_id?.toString()),
      passcode: encryptData(otp?.toString()),
    };

    const authToken = localStorage.getItem("authToken");

    const headers = {
      Authorization: `Bearer ${authToken}`,
    };
    // OTP Verification API
    try {
      const response = await apiRequest(
        "web_api/admin/verifyPasscode",
        "POST",
        payload,
        headers
      );
      if (response.data?.status_code == 200) {
        const encrypted = CryptoJS.AES.encrypt(
          "verifiedPasscode:true",
          secretKey
        ).toString();
        localStorage.setItem("verificationPasscodeToken", encrypted);
        navigate("/users/chechkInOut", {
          state: { user_id: userData?.user_id,premiseData }, // replace with your dynamic ID
        });
        setTimeout(() => {
          toast.success(response?.data?.message, {
            position: "top-right",
            autoClose: 2000,
          });
        }, 100);
      } else {
        setErrorMessage(response.data?.message);
        setIsVerifyingOtp(false);
      }
    } catch (error) {
      setErrorMessage("Invalid OTP. Try again.");
    } finally {
      setIsVerifyingOtp(false);
    }
  };

  const passcodeInputRef = useRef(null);

  useEffect(() => {
    if (open && passcodeInputRef.current) {
      passcodeInputRef.current.focus(); // Ensures focus when dialog opens
    }
  }, [open]);

  const handleChange = (e) => {
    // The input value is masked, so we can't use e.target.value directly
    const input = e.nativeEvent.data; // This is the actual char typed (may be null for deletions)
    const inputType = e.nativeEvent.inputType; // e.g. 'insertText', 'deleteContentBackward'

    if (inputType === "deleteContentBackward") {
      // User deleted a character: remove last char from otp
      setOtp((prev) => prev.slice(0, -1));
    } else if (input && /^\d$/.test(input)) {
      // User typed a digit
      setOtp((prev) => (prev.length < 4 ? prev + input : prev));
    }
    // else ignore input (non-digit or max length exceeded)
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      verifyOtp();
    }
  };

  return (
    // <Dialog open={open} onClose={handleClose}>
    //   <DialogTitle>Verify Passcode</DialogTitle>
    //   <DialogContent>
    //     {/* <Typography variant="h6" color="primary" sx={{ mt: 2 }}>
    //           OTP sent to {phone}
    //         </Typography> */}
    //     <TextField
    //       fullWidth
    //       label={
    //         <span>
    //           Enter passcode <span style={{ color: "red" }}>*</span>
    //         </span>
    //       }
    //       variant="outlined"
    //       value={otp}
    //       onChange={(e) => {
    //         const value = e.target.value;
    //         if (/^\d{0,4}$/.test(value)) {
    //           // Allow only up to 4 digits
    //           setOtp(value);
    //           setErrorMessage("");
    //           setMessage("");
    //         }
    //       }}
    //       margin="dense"
    //       type="password" // Use text to disable increment/decrement arrows
    //       inputProps={{
    //         maxLength: 4, // Ensure max input length is 4
    //         inputMode: "numeric", // Mobile keyboards show number pad
    //         pattern: "[0-9]*", // Restrict to numbers
    //       }}
    //     />

    //     <Button
    //       variant="contained"
    //       color="primary"
    //       fullWidth
    //       onClick={verifyOtp}
    //       sx={{ mt: 2 }}
    //     >
    //       {isVerifyingOtp ? (
    //         <CircularProgress size={24} color="inherit" />
    //       ) : (
    //         "Verify"
    //       )}
    //     </Button>
    //     <Typography
    //       variant="body2"
    //       color="success"
    //       className="successMessageDiv"
    //       sx={{ mt: 2 }}
    //     >
    //       {message}
    //     </Typography>
    //     <Typography variant="body2" color="error" sx={{ mt: 2 }}>
    //       {errorMessage}
    //     </Typography>
    //   </DialogContent>
    //   <DialogActions>
    //     <Button onClick={handleClose} color="secondary">
    //       Close
    //     </Button>
    //   </DialogActions>
    // </Dialog>

    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Verify Passcode</DialogTitle>
      <DialogContent>
        {/* Autofocus + Enter-to-submit */}
        <TextField
          fullWidth
          label={
            <span>
              Enter passcode <span style={{ color: "red" }}>*</span>
            </span>
          }
          margin="dense"
          variant="outlined"
          autoFocus
          inputRef={passcodeInputRef}
          // Show dots for each character entered
          value={"•".repeat(otp.length)}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          autoComplete="off"
          inputProps={{
            maxLength: 4,
            inputMode: "numeric",
            pattern: "[0-9]*",
            autoComplete: "off",
            name: "otp",
          }}
        />

        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={verifyOtp}
          sx={{ mt: 2 }}
        >
          {isVerifyingOtp ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            "Verify"
          )}
        </Button>
        <Typography
          variant="body2"
          color="success"
          className="successMessageDiv"
          sx={{ mt: 2 }}
        >
          {message}
        </Typography>
        <Typography variant="body2" color="error" sx={{ mt: 2 }}>
          {errorMessage}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VerifyUserPasscode;
